"use strict";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19, _templateObject20, _templateObject21, _templateObject22, _templateObject23, _templateObject24, _templateObject25, _templateObject26, _templateObject27, _templateObject28, _templateObject29, _templateObject30, _templateObject31, _templateObject32, _templateObject33, _templateObject34, _templateObject35, _templateObject36, _templateObject37, _templateObject38, _templateObject39, _templateObject40, _templateObject41, _templateObject42, _templateObject43, _templateObject44, _templateObject45, _templateObject46, _templateObject47, _templateObject48, _templateObject49, _templateObject50, _templateObject51, _templateObject52, _templateObject53, _templateObject54, _templateObject55, _templateObject56, _templateObject57, _templateObject58, _templateObject59;
function _defineProperty2(e, r, t) { return (r = _toPropertyKey2(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey2(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey2(t) { var i = _toPrimitive2(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive2(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.KameleoonClient = void 0;
var _tsRes = require("ts-res"),
  _cacheManager = require("./cacheManager"),
  _clientConfiguration = require("./clientConfiguration"),
  _clientSettings = require("./clientSettings"),
  _constants = require("./constants"),
  _kameleoonData = require("./kameleoonData"),
  _kameleoonError = require("./kameleoonError"),
  _requester = require("./requester"),
  _storage = require("./storage"),
  _types = require("./types"),
  _utilities = require("./utilities"),
  _variationConfiguration = require("./variationConfiguration"),
  _eventSource = require("./eventSource"),
  _visitorCodeManager = require("./visitorCodeManager"),
  _eventManager = require("./eventManager"),
  _tracking = require("./tracking"),
  _logging = require("./logging");
function _defineProperty(a, b, c) {
  return (b = _toPropertyKey(b)) in a ? Object.defineProperty(a, b, {
    value: c,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : a[b] = c, a;
}
function _toPropertyKey(a) {
  var b = _toPrimitive(a, "string");
  return "symbol" == _typeof(b) ? b : b + "";
}
function _toPrimitive(a, b) {
  if ("object" != _typeof(a) || !a) return a;
  var c = a[Symbol.toPrimitive];
  if (void 0 !== c) {
    var d = c.call(a, b || "default");
    if ("object" != _typeof(d)) return d;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === b ? String : Number)(a);
}
var KameleoonClient = /*#__PURE__*/function () {
  function KameleoonClient(a) {
    _classCallCheck(this, KameleoonClient);
    var b;
    var c = a.siteCode,
      d = a.dependencies,
      e = a.configuration,
      f = a.internalConfiguration;
    _defineProperty(this, "variationConfiguration", void 0), _defineProperty(this, "clientConfiguration", void 0), _defineProperty(this, "dataManager", void 0), _defineProperty(this, "consentDataStorage", void 0), _defineProperty(this, "trackingCache", void 0), _defineProperty(this, "requester", void 0), _defineProperty(this, "externalPackageInfo", void 0), _defineProperty(this, "initialized", !1), _defineProperty(this, "visitorCodeManager", void 0), _defineProperty(this, "eventManager", void 0), _defineProperty(this, "tracker", void 0), _defineProperty(this, "environment", void 0);
    var g = null === f || void 0 === f ? void 0 : f.externals.externalLogger;
    g && _logging.KameleoonLogger.setLogger(g), _logging.KameleoonLogger.debug(_templateObject || (_templateObject = _taggedTemplateLiteral(["CALL: new KameleoonClient(siteCode: ", ", dependencies: ", ", configuration: ", ")"])), c, d, e);
    var _clientSettings$Clien = new _clientSettings.ClientSettings(c, e),
      h = _clientSettings$Clien.settings;
    this.environment = h.environment;
    var _f$externals = f.externals,
      i = _f$externals.externalStorage,
      j = _f$externals.externalEventSource,
      k = _f$externals.externalPackageInfo,
      l = _f$externals.externalVisitorCodeManager,
      m = _f$externals.externalRequester,
      n = _f$externals.externalPRNG,
      o = f.settings.useAbortController,
      p = new _cacheManager.CacheManager(_constants.CACHE_CLEANUP_TIMEOUT),
      q = new _storage.DataStorage(i, _storage.KameleoonStorageKey.ClientData),
      r = new _storage.DataStorage(i, _storage.KameleoonStorageKey.TargetingData),
      s = new _storage.DataStorage(i, _storage.KameleoonStorageKey.DataInfo),
      t = new _storage.DataStorage(i, _storage.KameleoonStorageKey.VariationData),
      u = new _storage.DataStorage(i, _storage.KameleoonStorageKey.ForcedExperimentVariation),
      v = new _storage.DataStorage(i, _storage.KameleoonStorageKey.ForcedFeatureVariation),
      w = new _storage.DataStorage(i, _storage.KameleoonStorageKey.ConsentData),
      x = new _storage.DataStorage(i, _storage.KameleoonStorageKey.TrackingData),
      y = new _kameleoonData.DataManager({
        dataStorage: r,
        infoStorage: s,
        cleanupInterval: h.cleanupInterval,
        packageInfo: k
      }),
      z = null !== (b = null === d || void 0 === d ? void 0 : d.urlProvider) && void 0 !== b ? b : new _requester.UrlProvider();
    z.initialize({
      domain: h.networkDomain,
      siteCode: h.siteCode,
      packageInfo: k,
      environment: h.environment
    });
    var A = new _requester.Requester({
        urlProvider: z,
        useAbortController: o,
        packageInfo: k,
        externalRequester: m,
        requestTimeout: h.requestTimeout,
        trackRetryDelay: h.trackRetryDelay
      }),
      B = new _eventSource.KameleoonEventSource({
        siteCode: h.siteCode,
        externalEventSource: j,
        urlProvider: z
      }),
      C = new _eventManager.EventManager(),
      D = new _clientConfiguration.ClientConfiguration({
        urlProvider: z,
        storage: q,
        updateInterval: h.updateInterval,
        dataManager: y,
        eventManager: C,
        requester: A,
        eventSource: B,
        externalVisitorCodeManager: l
      }),
      E = new _variationConfiguration.VariationConfiguration(t, u, v, l, D),
      F = new _tracking.Tracker({
        dataManager: y,
        trackingStorage: x,
        variationConfiguration: E,
        requester: A,
        trackingInterval: h.trackingInterval,
        prng: n
      });
    this.tracker = F, this.variationConfiguration = E, this.requester = A, this.trackingCache = p, this.dataManager = y, this.clientConfiguration = D, this.externalPackageInfo = k, this.consentDataStorage = w, this.visitorCodeManager = l, this.eventManager = C, null !== h.cleanupInterval && new _storage.StorageCleanupManager(i, h.cleanupInterval), _logging.KameleoonLogger.debug(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["RETURN: new KameleoonClient(siteCode: ", ", dependencies: ", ", configuration: ", ")"])), c, d, e);
  }
  return _createClass(KameleoonClient, [{
    key: "initialize",
    value: function () {
      var _initialize = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var a;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _logging.KameleoonLogger.info("CALL: KameleoonClient.initialize()");
              _context.next = 3;
              return this.clientConfiguration.initialize();
            case 3:
              a = _context.sent;
              return _context.abrupt("return", (a["throw"](), this.initialized = !0, _logging.KameleoonLogger.info(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["RETURN: KameleoonClient.initialize() -> (result: ", ")"])), a.ok), a.ok));
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function initialize() {
        return _initialize.apply(this, arguments);
      }
      return initialize;
    }()
  }, {
    key: "addData",
    value: function addData(a) {
      var _this$dataManager;
      for (var b = arguments.length, c = Array(1 < b ? b - 1 : 0), d = 1; d < b; d++) c[d - 1] = arguments[d];
      if (_logging.KameleoonLogger.info(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["CALL: KameleoonClient.addData(visitorCode: ", ", data: ", ")"])), a, c), this.visitorCodeManager.validateVisitorCode(a)["throw"](), !this.initialized) throw new _kameleoonError.KameleoonError(_kameleoonError.KameleoonException.Initialization);
      (_this$dataManager = this.dataManager).storeData.apply(_this$dataManager, [a].concat(c))["throw"](), _logging.KameleoonLogger.info(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["RETURN: KameleoonClient.addData(visitorCode: ", ", data: ", ")"])), a, c);
    }
  }, {
    key: "getRemoteVisitorData",
    value: function () {
      var _getRemoteVisitorData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(a) {
        var b, _a$shouldAddData, c, _a$filters, d, e, f, g, h, _utilities$Parser$par, i, j, k, l, _iterator, _step, _d;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              b = a.visitorCode, _a$shouldAddData = a.shouldAddData, c = _a$shouldAddData === void 0 ? !0 : _a$shouldAddData, _a$filters = a.filters, d = _a$filters === void 0 ? _constants.DEFAULT_VISITOR_DATA_FILTERS : _a$filters;
              if (!(_logging.KameleoonLogger.info(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["CALL: KameleoonClient.getRemoteVisitorData(visitorCode: ", ", shouldAddData: ", ", filters: ", ")"])), b, c, d), !this.initialized)) {
                _context2.next = 3;
                break;
              }
              throw new _kameleoonError.KameleoonError(_kameleoonError.KameleoonException.Initialization);
            case 3:
              this.visitorCodeManager.validateVisitorCode(b)["throw"]();
              e = d.previousVisitAmount;
              if (!("number" == typeof e && (1 > e || 25 < e))) {
                _context2.next = 7;
                break;
              }
              throw new _kameleoonError.KameleoonError(_kameleoonError.KameleoonException.VisitAmount);
            case 7:
              f = this.dataManager.isUniqueIdentifier(b);
              _context2.next = 10;
              return this.requester.getVisitorData({
                visitorCode: b,
                filters: d,
                isMappingIdentifier: f
              });
            case 10:
              g = _context2.sent;
              h = g["throw"]();
              _utilities$Parser$par = _utilities.Parser.parseVisitorData({
                data: h,
                filters: d,
                visitorCode: b,
                dataManager: this.dataManager,
                variationConfiguration: this.variationConfiguration
              });
              i = _utilities$Parser$par.visitorData;
              j = _utilities$Parser$par.storageVisitorData;
              k = _utilities$Parser$par.visitsData;
              l = _utilities$Parser$par.mappingIdentifier;
              _iterator = _createForOfIteratorHelper(j);
              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  _d = _step.value;
                  (c || this.dataManager.isPersistentCustomData(_d)) && this.addData(b, _d);
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
              return _context2.abrupt("return", (k && c && this.addData(b, k), null !== d && void 0 !== d && d.visitorCode && l && this.dataManager.setMappingIdentifier(b, l), _logging.KameleoonLogger.info(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["RETURN: KameleoonClient.getRemoteVisitorData(visitorCode: ", ", shouldAddData: ", ", filters: ", ") -> (visitorData: ", ")"])), b, c, d, i), i));
            case 20:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function getRemoteVisitorData(_x) {
        return _getRemoteVisitorData.apply(this, arguments);
      }
      return getRemoteVisitorData;
    }()
  }, {
    key: "trackConversion",
    value: function trackConversion(a) {
      var b = a.visitorCode,
        c = a.goalId,
        d = a.revenue;
      _logging.KameleoonLogger.info(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["CALL: KameleoonClient.trackConversion(visitorCode: ", ", goalId: ", ", revenue: ", ")"])), b, c, d), this.addData(b, new _kameleoonData.Conversion({
        goalId: c,
        revenue: d
      })), this.flush(b), _logging.KameleoonLogger.info(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["RETURN: KameleoonClient.trackConversion(visitorCode: ", ", goalId: ", ", revenue: ", ")"])), b, c, d);
    }
  }, {
    key: "flush",
    value: function flush(a) {
      if (_logging.KameleoonLogger.info(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["CALL: KameleoonClient.flush(visitorCode: ", ")"])), a), !this.initialized) throw new _kameleoonError.KameleoonError(_kameleoonError.KameleoonException.Initialization);
      if ("string" == typeof a) return this.visitorCodeManager.validateVisitorCode(a)["throw"](), this.tracker.scheduleVisitor(a, this._isConsentProvided(a)), void _logging.KameleoonLogger.info(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["RETURN: KameleoonClient.flush(visitorCode: ", ")"])), a);
      var _iterator2 = _createForOfIteratorHelper(this.dataManager.unsentDataVisitors),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var b = _step2.value;
          this.tracker.scheduleVisitor(b, this._isConsentProvided(b));
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      _logging.KameleoonLogger.info(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["RETURN: KameleoonClient.flush(visitorCode: ", ")"])), a);
    }
  }, {
    key: "getFeatureFlags",
    value: function getFeatureFlags() {
      if (_logging.KameleoonLogger.info("CALL: KameleoonClient.getFeatureFlags()"), !this.initialized) throw new _kameleoonError.KameleoonError(_kameleoonError.KameleoonException.Initialization);
      var a = this.clientConfiguration.featureFlags,
        b = [];
      return a.forEach(function (a) {
        var c = a.id,
          d = a.featureKey;
        b.push({
          id: c,
          key: d
        });
      }), _logging.KameleoonLogger.info(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["RETURN: KameleoonClient.getFeatureFlags() -> (FeatureFlags: ", ")"])), b), b;
    }
  }, {
    key: "getVisitorFeatureFlags",
    value: function getVisitorFeatureFlags(a) {
      if (_logging.KameleoonLogger.info(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["CALL: KameleoonClient.getVisitorFeatureFlags(visitorCode: ", ")"])), a), !this.initialized) throw new _kameleoonError.KameleoonError(_kameleoonError.KameleoonException.Initialization);
      this.visitorCodeManager.validateVisitorCode(a)["throw"]();
      var b = this._getActiveFeatureVariations(a),
        c = [];
      return b.forEach(function (a) {
        var b = a.featureFlagId,
          d = a.featureKey;
        c.push({
          id: b,
          key: d
        });
      }), _logging.KameleoonLogger.info(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["RETURN: KameleoonClient.getVisitorFeatureFlags(visitorCode: ", ") -> (FeatureFlags: ", ")"])), a, c), c;
    }
  }, {
    key: "getVariation",
    value: function getVariation(a) {
      var b = a.visitorCode,
        c = a.featureKey,
        _a$track = a.track,
        d = _a$track === void 0 ? !0 : _a$track;
      _logging.KameleoonLogger.info(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["CALL: KameleoonClient.getVariation(visitorCode: ", ", featureKey: ", ", track: ", ")"])), b, c, d), this.visitorCodeManager.validateVisitorCode(b)["throw"]();
      var e = this._getFeatureVariation({
        visitorCode: b,
        featureKey: c,
        track: d
      })["throw"]();
      return _logging.KameleoonLogger.info(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["RETURN: KameleoonClient.getVariation(visitorCode: ", ", featureKey: ", ", track: ", ") -> (variation: ", ")"])), b, c, d, e), e;
    }
  }, {
    key: "getVariations",
    value: function getVariations(a) {
      var b = a.visitorCode,
        _a$onlyActive = a.onlyActive,
        c = _a$onlyActive === void 0 ? !1 : _a$onlyActive,
        _a$track2 = a.track,
        d = _a$track2 === void 0 ? !0 : _a$track2;
      _logging.KameleoonLogger.info(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["CALL: KameleoonClient.getVariations(visitorCode: ", ", onlyActive: ", ", track: ", ")"])), b, c, d), this.visitorCodeManager.validateVisitorCode(b)["throw"]();
      var e = new Map(),
        f = this.clientConfiguration.featureFlags;
      var _iterator3 = _createForOfIteratorHelper(f.values()),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var g = _step3.value;
          var _a = this._getFeatureVariation({
            visitorCode: b,
            featureKey: g.featureKey,
            track: d
          });
          _a.ok && (!c || _a.data.key !== _constants.OFF_VARIATION_KEY) && e.set(g.featureKey, _a.data);
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      return _logging.KameleoonLogger.info(_templateObject19 || (_templateObject19 = _taggedTemplateLiteral(["RETURN: KameleoonClient.getVariations(visitorCode: ", ", onlyActive: ", ", track: ", ") -> (variations: ", ")"])), b, c, d, e), e;
    }
  }, {
    key: "getActiveFeatureFlags",
    value: function getActiveFeatureFlags(a) {
      var _this = this;
      if (_logging.KameleoonLogger.info(_templateObject20 || (_templateObject20 = _taggedTemplateLiteral(["CALL: KameleoonClient.getActiveFeatureFlags(visitorCode: ", ")"])), a), !this.initialized) throw new _kameleoonError.KameleoonError(_kameleoonError.KameleoonException.Initialization);
      this.visitorCodeManager.validateVisitorCode(a)["throw"]();
      var b = this._getActiveFeatureVariations(a),
        c = new Map();
      return b.forEach(function (b) {
        var d = b.variationKey,
          e = b.featureKey,
          f = b.variationId,
          g = b.experimentId;
        var h = [];
        null !== f && null !== g && (h = _this._getFeatureVariables({
          visitorCode: a,
          featureKey: e,
          variationKey: d
        }));
        var i = h.map(function (a) {
          return _utilities.Parser.parseFeatureVariable(a)["throw"]();
        });
        c.set(b.featureKey, {
          key: d,
          id: f,
          experimentId: g,
          variables: i
        });
      }), _logging.KameleoonLogger.info(_templateObject21 || (_templateObject21 = _taggedTemplateLiteral(["RETURN: KameleoonClient.getActiveFeatureFlags(visitorCode: ", ") -> (FeatureFlags: ", ")"])), a, c), c;
    }
  }, {
    key: "getFeatureFlagVariationKey",
    value: function getFeatureFlagVariationKey(a, b) {
      _logging.KameleoonLogger.info(_templateObject22 || (_templateObject22 = _taggedTemplateLiteral(["CALL: KameleoonClient.getFeatureFlagVariationKey(visitorCode: ", ", featureKey: ", ")"])), a, b), this.visitorCodeManager.validateVisitorCode(a)["throw"]();
      var _this$_getFeatureVari = this._getFeatureVariation({
          visitorCode: a,
          featureKey: b,
          track: !0
        })["throw"](),
        c = _this$_getFeatureVari.key;
      return _logging.KameleoonLogger.info(_templateObject23 || (_templateObject23 = _taggedTemplateLiteral(["RETURN: KameleoonClient.getFeatureFlagVariationKey(visitorCode: ", ", featureKey: ", ") -> (variationKey: ", ")"])), a, b, c), c;
    }
  }, {
    key: "getFeatureFlagVariable",
    value: function getFeatureFlagVariable(a) {
      var b = a.visitorCode,
        c = a.featureKey,
        d = a.variableKey;
      _logging.KameleoonLogger.info(_templateObject24 || (_templateObject24 = _taggedTemplateLiteral(["CALL: KameleoonClient.getFeatureFlagVariable(visitorCode: ", ", featureKey: ", ", variableKey: ", ")"])), b, c, d), this.visitorCodeManager.validateVisitorCode(b)["throw"]();
      var _this$_getFeatureVari2 = this._getFeatureVariation({
          visitorCode: b,
          featureKey: c,
          track: !0
        })["throw"](),
        e = _this$_getFeatureVari2.key,
        f = this._getFeatureVariables({
          visitorCode: b,
          featureKey: c,
          variationKey: e
        }),
        g = f.find(function (a) {
          return a.key === d;
        });
      if (!g) throw new _kameleoonError.KameleoonError(_kameleoonError.KameleoonException.FeatureFlagVariableNotFound, d, b);
      var _utilities$Parser$par2 = _utilities.Parser.parseFeatureVariable(g)["throw"](),
        h = _utilities$Parser$par2.type,
        i = _utilities$Parser$par2.value,
        j = {
          type: h,
          value: i
        };
      return _logging.KameleoonLogger.info(_templateObject25 || (_templateObject25 = _taggedTemplateLiteral(["RETURN: KameleoonClient.getFeatureFlagVariable(visitorCode: ", ", featureKey: ", ", variableKey: ", ") -> (FeatureFlagVariable: ", ")"])), b, c, d, j), j;
    }
  }, {
    key: "getFeatureFlagVariables",
    value: function getFeatureFlagVariables(a, b) {
      _logging.KameleoonLogger.info(_templateObject26 || (_templateObject26 = _taggedTemplateLiteral(["CALL: KameleoonClient.getFeatureFlagVariables(visitorCode: ", ", featureKey: ", ")"])), a, b), this.visitorCodeManager.validateVisitorCode(a)["throw"]();
      var _this$_getFeatureVari3 = this._getFeatureVariation({
          visitorCode: a,
          featureKey: b,
          track: !0
        })["throw"](),
        c = _this$_getFeatureVari3.key,
        d = this._getFeatureVariables({
          visitorCode: a,
          featureKey: b,
          variationKey: c
        }),
        e = [];
      var _iterator4 = _createForOfIteratorHelper(d),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var _c = _step4.value;
          var _a2 = _utilities.Parser.parseFeatureVariable(_c)["throw"]();
          e.push(_a2);
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
      return _logging.KameleoonLogger.info(_templateObject27 || (_templateObject27 = _taggedTemplateLiteral(["RETURN: KameleoonClient.getFeatureFlagVariables(visitorCode: ", ", featureKey: ", ") -> (FeatureFlagVariables: ", ")"])), a, b, e), e;
    }
  }, {
    key: "isFeatureFlagActive",
    value: function isFeatureFlagActive(a, b) {
      var _ref;
      var c = "",
        d = "",
        e = !0;
      "string" == typeof a ? (_logging.KameleoonLogger.info(_templateObject28 || (_templateObject28 = _taggedTemplateLiteral(["CALL: KameleoonClient.isFeatureFlagActive(visitorCode: ", ", featureKey: ", ")"])), c, d), c = a, d = b) : (_logging.KameleoonLogger.info(_templateObject29 || (_templateObject29 = _taggedTemplateLiteral(["CALL: KameleoonClient.isFeatureFlagActive(visitorCode: ", ", featureKey: ", ", track ", ")"])), c, d, e), _ref = [a.visitorCode, a.featureKey], c = _ref[0], d = _ref[1], _ref, a.track !== void 0 && (e = a.track)), this.visitorCodeManager.validateVisitorCode(c)["throw"]();
      try {
        var _this$_getFeatureVari4 = this._getFeatureVariation({
            visitorCode: c,
            featureKey: d,
            track: e
          })["throw"](),
          _a3 = _this$_getFeatureVari4.key,
          _b = _a3 !== _constants.OFF_VARIATION_KEY;
        return _logging.KameleoonLogger.info(_templateObject30 || (_templateObject30 = _taggedTemplateLiteral(["RETURN: KameleoonClient.isFeatureFlagActive(visitorCode: ", ", featureKey: ", ", track: ", ") -> (isActive: ", ")"])), c, d, e, _b), _b;
      } catch (a) {
        if (a instanceof _kameleoonError.KameleoonError && a.type === _kameleoonError.KameleoonException.FeatureFlagEnvironmentDisabled) return _logging.KameleoonLogger.info(_templateObject31 || (_templateObject31 = _taggedTemplateLiteral(["RETURN: KameleoonClient.isFeatureFlagActive(visitorCode: ", ", featureKey: ", ", track: ", ") -> (isActive: false)"])), c, d, e), !1;
        throw a;
      }
    }
  }, {
    key: "getRemoteData",
    value: function () {
      var _getRemoteData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(a) {
        var b;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _logging.KameleoonLogger.info(_templateObject32 || (_templateObject32 = _taggedTemplateLiteral(["CALL: KameleoonClient.getRemoteData(key: ", ")"])), a);
              _context3.next = 3;
              return this.requester.getRemoteData(a);
            case 3:
              b = _context3.sent;
              return _context3.abrupt("return", (_logging.KameleoonLogger.info(_templateObject33 || (_templateObject33 = _taggedTemplateLiteral(["RETURN: KameleoonClient.getRemoteData(key: ", ") -> (remoteData: ", ")"])), a, b), b["throw"]()));
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function getRemoteData(_x2) {
        return _getRemoteData.apply(this, arguments);
      }
      return getRemoteData;
    }()
  }, {
    key: "getVisitorWarehouseAudience",
    value: function () {
      var _getVisitorWarehouseAudience = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(a) {
        var b, c, d, e, f;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              b = a.visitorCode, c = a.customDataIndex, d = a.warehouseKey;
              _logging.KameleoonLogger.info(_templateObject34 || (_templateObject34 = _taggedTemplateLiteral(["CALL: KameleoonClient.getVisitorWarehouseAudience(visitorCode: ", ", customDataIndex: ", ", warehouseKey: ", ")"])), b, c, d), this.visitorCodeManager.validateVisitorCode(b)["throw"]();
              _context4.next = 4;
              return this.getRemoteData(d || b);
            case 4:
              e = _context4.sent;
              if (e) {
                _context4.next = 7;
                break;
              }
              throw new _kameleoonError.KameleoonError(_kameleoonError.KameleoonException.RemoteData, "No data found for ".concat(d || b, " key"));
            case 7:
              if (!(!e[_constants.WAREHOUSE_AUDIENCE_KEY] || 0 === Object.keys(e[_constants.WAREHOUSE_AUDIENCE_KEY]).length)) {
                _context4.next = 9;
                break;
              }
              return _context4.abrupt("return", (_logging.KameleoonLogger.info(_templateObject35 || (_templateObject35 = _taggedTemplateLiteral(["RETURN: KameleoonClient.getVisitorWarehouseAudience(visitorCode: ", ", customDataIndex: ", ", warehouseKey: ", ") -> (customData: null)"])), b, c, d), null));
            case 9:
              f = _construct(_kameleoonData.CustomData, [c].concat(_toConsumableArray(Object.keys(e[_constants.WAREHOUSE_AUDIENCE_KEY]))));
              return _context4.abrupt("return", (this.dataManager.storeData(b, f), _logging.KameleoonLogger.info(_templateObject36 || (_templateObject36 = _taggedTemplateLiteral(["RETURN: KameleoonClient.getVisitorWarehouseAudience(visitorCode: ", ", customDataIndex: ", ", warehouseKey: ", ") -> (customData: ", ")"])), b, c, d, f), f));
            case 11:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function getVisitorWarehouseAudience(_x3) {
        return _getVisitorWarehouseAudience.apply(this, arguments);
      }
      return getVisitorWarehouseAudience;
    }()
  }, {
    key: "onEvent",
    value: function onEvent(a, b) {
      if (_logging.KameleoonLogger.info(_templateObject37 || (_templateObject37 = _taggedTemplateLiteral(["CALL: KameleoonClient.onEvent(event: ", ", callback)"])), a), !this.initialized) throw new _kameleoonError.KameleoonError(_kameleoonError.KameleoonException.Initialization);
      this.eventManager.addEventHandler(a, b), _logging.KameleoonLogger.info(_templateObject38 || (_templateObject38 = _taggedTemplateLiteral(["RETURN: KameleoonClient.onEvent(event: ", ", callback)"])), a);
    }
  }, {
    key: "getEngineTrackingCode",
    value: function getEngineTrackingCode(a) {
      _logging.KameleoonLogger.info(_templateObject39 || (_templateObject39 = _taggedTemplateLiteral(["CALL: KameleoonClient.getEngineTrackingCode(visitorCode: ", ")"])), a), this.visitorCodeManager.validateVisitorCode(a)["throw"]();
      var b = _utilities.Utilities.getTrackingCode(this.trackingCache, a);
      return _logging.KameleoonLogger.info(_templateObject40 || (_templateObject40 = _taggedTemplateLiteral(["RETURN: KameleoonClient.getEngineTrackingCode(visitorCode: ", ") -> (trackingCode: ", ")"])), a, b), b;
    }
  }, {
    key: "isInitialized",
    value: function isInitialized() {
      return _logging.KameleoonLogger.debug(_templateObject41 || (_templateObject41 = _taggedTemplateLiteral(["CALL/RETURN: KameleoonClient.isInitialized() -> (initialized: ", ")"])), this.initialized), this.initialized;
    }
  }, {
    key: "setLogLevel",
    value: function setLogLevel(a) {
      _logging.KameleoonLogger.setLogLevel(a);
    }
  }, {
    key: "setForcedVariation",
    value: function setForcedVariation(a) {
      var b = a.visitorCode,
        c = a.experimentId,
        d = a.variationKey,
        _a$forceTargeting = a.forceTargeting,
        e = _a$forceTargeting === void 0 ? !0 : _a$forceTargeting;
      _logging.KameleoonLogger.info(_templateObject42 || (_templateObject42 = _taggedTemplateLiteral(["CALL: KameleoonClient.setForcedVariation(visitorCode: '", "', experimentId: ", ", variationKey: '", "', forceTargeting: ", ")"])), b, c, d, e), this.visitorCodeManager.validateVisitorCode(b)["throw"](), this._setForcedVariation({
        visitorCode: b,
        experimentId: c,
        variationKey: d,
        forceTargeting: e
      })["throw"](), _logging.KameleoonLogger.info(_templateObject43 || (_templateObject43 = _taggedTemplateLiteral(["RETURN: KameleoonClient.setForcedVariation(visitorCode: '", "', experimentId: ", ", variationKey: '", "', forceTargeting: ", ")"])), b, c, d, e);
    }
  }, {
    key: "setUserConsent",
    value: function setUserConsent(a) {
      var b = a.visitorCode,
        c = a.consent,
        d = a.setData;
      _logging.KameleoonLogger.info(_templateObject44 || (_templateObject44 = _taggedTemplateLiteral(["CALL: KameleoonClient.setUserConsent(visitorCode: ", ", consent: ", ", setData: ", ")"])), b, c, d), this.visitorCodeManager.validateVisitorCode(b)["throw"](), this.updateConsentData(b, c), c ? d({
        visitorCode: b,
        key: _storage.KameleoonStorageKey.VisitorCode,
        maxAge: _visitorCodeManager.DEFAULT_MAX_AGE,
        path: _visitorCodeManager.PATH
      }) : this.visitorCodeManager.consentRequired && d({
        visitorCode: "",
        key: _storage.KameleoonStorageKey.VisitorCode,
        maxAge: _visitorCodeManager.ZERO_MAX_AGE,
        path: _visitorCodeManager.PATH
      }), _logging.KameleoonLogger.info(_templateObject45 || (_templateObject45 = _taggedTemplateLiteral(["RETURN: KameleoonClient.setUserConsent(visitorCode: ", ", consent: ", ", setData: ", ")"])), b, c, d);
    }
  }, {
    key: "updateConsentData",
    value: function updateConsentData(a, b) {
      var c = this.consentDataStorage.read();
      if (!c.ok) return void (c.error.type === _kameleoonError.KameleoonException.StorageEmpty && this.consentDataStorage.write(_defineProperty2({}, a, {
        consent: b
      })));
      var d = c.data;
      d[a] = {
        consent: b
      }, this.consentDataStorage.write(d);
    }
  }, {
    key: "_isConsentProvided",
    value: function _isConsentProvided(a) {
      _logging.KameleoonLogger.debug(_templateObject46 || (_templateObject46 = _taggedTemplateLiteral(["CALL: KameleoonClient._isConsentProvided(visitorCode: ", ")"])), a);
      var b = this.clientConfiguration.isConsentRequired,
        c = this.consentDataStorage.read();
      var d = !1;
      if (!b) d = !0;else if (c.ok) {
        var _b2 = c.data[a];
        d = "boolean" == typeof _b2 ? _b2 : _b2 && _b2.consent;
      }
      return _logging.KameleoonLogger.debug(_templateObject47 || (_templateObject47 = _taggedTemplateLiteral(["RETURN: KameleoonClient._isConsentProvided(visitorCode: ", ") -> (isConsentProvided: ", ")"])), a, d), d;
    }
  }, {
    key: "_getFeatureVariables",
    value: function _getFeatureVariables(a) {
      var b = a.visitorCode,
        c = a.featureKey,
        d = a.variationKey;
      _logging.KameleoonLogger.debug(_templateObject48 || (_templateObject48 = _taggedTemplateLiteral(["CALL: KameleoonClient._getFeatureVariables(visitorCode: ", ", featureKey: ", ", variationKey: ", ")"])), b, c, d);
      var e = this.clientConfiguration.featureFlags,
        f = e.get(c);
      if (!f) throw new _kameleoonError.KameleoonError(_kameleoonError.KameleoonException.FeatureFlagConfigurationNotFound, c);
      var g = f.variations.find(function (a) {
        return a.key === d;
      });
      if (!g) throw new _kameleoonError.KameleoonError(_kameleoonError.KameleoonException.FeatureFlagVariationNotFound, d, b);
      return _logging.KameleoonLogger.debug(_templateObject49 || (_templateObject49 = _taggedTemplateLiteral(["RETURN: KameleoonClient._getFeatureVariables(visitorCode: ", ", featureKey: ", ", variationKey: ", ") -> (variables: ", ")"])), b, c, d, g.variables), g.variables;
    }
  }, {
    key: "_getActiveFeatureVariations",
    value: function _getActiveFeatureVariations(a) {
      _logging.KameleoonLogger.debug(_templateObject50 || (_templateObject50 = _taggedTemplateLiteral(["CALL: KameleoonClient._getActiveFeatureVariations(visitorCode: ", ")"])), a);
      var b = this.clientConfiguration.featureFlags,
        c = [],
        d = this.dataManager.getVisitorData(a),
        e = this.dataManager.getVisitorIdentifier(a);
      var _iterator5 = _createForOfIteratorHelper(b.values()),
        _step5;
      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var f = _step5.value;
          if (!f.environmentEnabled) continue;
          var _b3 = this.variationConfiguration.getVariation({
            visitorCode: a,
            visitorIdentifier: e,
            targetingData: d,
            featureFlag: f,
            clientConfiguration: this.clientConfiguration,
            dataManager: this.dataManager,
            packageInfo: this.externalPackageInfo
          })["throw"]();
          this.eventManager.fireEvent(_eventManager.EventType.Evaluation, {
            featureKey: f.featureKey,
            variation: {
              key: _b3.variationKey,
              experimentId: _b3.experimentId,
              id: _b3.variationId
            }
          }), _b3.variationKey !== _constants.OFF_VARIATION_KEY && c.push(_b3);
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
      return _logging.KameleoonLogger.debug(_templateObject51 || (_templateObject51 = _taggedTemplateLiteral(["RETURN: KameleoonClient._getActiveFeatureVariations(visitorCode: ", ") -> (activeVariations: ", ")"])), a, c), c;
    }
  }, {
    key: "_getFeatureVariation",
    value: function _getFeatureVariation(a) {
      var b = a.visitorCode,
        c = a.featureKey,
        d = a.track;
      if (_logging.KameleoonLogger.debug(_templateObject52 || (_templateObject52 = _taggedTemplateLiteral(["CALL: KameleoonClient._getFeatureVariation(visitorCode: ", ", featureKey: ", ", track: ", ")"])), b, c, d), !this.initialized) return (0, _tsRes.Err)(new _kameleoonError.KameleoonError(_kameleoonError.KameleoonException.Initialization));
      var e = this.clientConfiguration.featureFlags,
        f = e.get(c);
      if (!f) return (0, _tsRes.Err)(new _kameleoonError.KameleoonError(_kameleoonError.KameleoonException.FeatureFlagConfigurationNotFound, c));
      if (!f.environmentEnabled) return (0, _tsRes.Err)(new _kameleoonError.KameleoonError(_kameleoonError.KameleoonException.FeatureFlagEnvironmentDisabled, f.featureKey, this.environment));
      var g,
        h = !1,
        i = !1;
      var j = this.variationConfiguration.getForcedFeatureVariation(b, c);
      if (j.ok) {
        var _a4 = j.data;
        if (_a4) {
          var k, l;
          _logging.KameleoonLogger.debug(_templateObject53 || (_templateObject53 = _taggedTemplateLiteral(["Forced variation for visitor ", " and feature ", " is found: ", ""])), b, c, _a4), h = !0, i = !0;
          var _d2 = f.defaultVariationKey;
          _a4.varByExp ? _d2 = _a4.varByExp.variationKey : _a4.rule && _a4.rule.type === _clientConfiguration.RuleType.EXPERIMENTATION && (_d2 = _constants.OFF_VARIATION_KEY), g = {
            variationKey: _d2,
            variationId: (null === (k = _a4.varByExp) || void 0 === k ? void 0 : k.variationId) || null,
            experimentId: (null === (l = _a4.rule) || void 0 === l ? void 0 : l.experimentId) || null,
            rule: _a4.rule || null
          };
        }
      }
      if (!g) {
        var _a5 = this.dataManager.getVisitorData(b),
          _c2 = this.dataManager.getVisitorIdentifier(b);
        g = this.variationConfiguration.getVariation({
          visitorCode: b,
          visitorIdentifier: _c2,
          featureFlag: f,
          track: d,
          withAssignment: !0,
          targetingData: _a5,
          clientConfiguration: this.clientConfiguration,
          dataManager: this.dataManager,
          packageInfo: this.externalPackageInfo
        })["throw"]();
      }
      h || (i && null !== g.experimentId && null !== g.variationId && this.variationConfiguration.updateStoredVariations(b, _defineProperty2({}, g.experimentId, {
        variationId: g.variationId,
        isTargetedRule: g.rule.type === _clientConfiguration.RuleType.TARGETED_DELIVERY,
        status: d ? _types.TrackingStatus.Unsent : _types.TrackingStatus.Sent
      })), this.eventManager.fireEvent(_eventManager.EventType.Evaluation, {
        featureKey: c,
        variation: {
          key: g.variationKey,
          experimentId: g.experimentId,
          id: g.variationId
        }
      }));
      var _g = g,
        m = _g.experimentId,
        n = _g.variationId,
        o = _g.variationKey;
      var p = new Map(),
        q = !1;
      try {
        var _a6 = this._getFeatureVariables({
          visitorCode: b,
          featureKey: c,
          variationKey: o
        });
        _a6.forEach(function (a) {
          q || a.type !== _types.VariableType.JS && a.type !== _types.VariableType.CSS || (q = !0);
          var b = _utilities.Parser.parseFeatureVariable(a)["throw"]();
          p.set(a.key, b);
        });
      } catch (_) {}
      m && "number" == typeof n && !h && _utilities.Utilities.updateCache({
        cacheManager: this.trackingCache,
        hasJsCssVariables: q,
        visitorCode: b,
        experimentId: m,
        variationId: n
      }), d && !h && this.tracker.scheduleVisitor(b, this._isConsentProvided(b));
      return _logging.KameleoonLogger.debug(_templateObject54 || (_templateObject54 = _taggedTemplateLiteral(["RETURN: KameleoonClient._getFeatureVariation(visitorCode: ", ", featureKey: ", ", track: ", ") -> (variation: ", ")"])), b, c, d, g), (0, _tsRes.Ok)({
        key: o,
        id: n,
        experimentId: m,
        variables: p
      });
    }
  }, {
    key: "_setForcedVariation",
    value: function _setForcedVariation(a) {
      var b = a.visitorCode,
        c = a.experimentId,
        d = a.variationKey,
        _a$forceTargeting2 = a.forceTargeting,
        e = _a$forceTargeting2 === void 0 ? !0 : _a$forceTargeting2;
      if (_logging.KameleoonLogger.debug(_templateObject55 || (_templateObject55 = _taggedTemplateLiteral(["CALL: KameleoonClient._setForcedVariation(visitorCode: '", "', experimentId: ", ", variationKey: '", "', forceTargeting: ", ")"])), b, c, d, e), null === d) {
        var _a7 = this.variationConfiguration.updateForcedExperimentVariation(b, c, null);
        return _logging.KameleoonLogger.debug(_templateObject56 || (_templateObject56 = _taggedTemplateLiteral(["RETURN: KameleoonClient._setForcedVariation(visitorCode: '", "', experimentId: ", ", variationKey: '", "', forceTargeting: ", ") -> (writeResult: ", ")"])), b, c, d, e, _a7), _a7;
      }
      var f = null,
        g = null;
      if (f = this.clientConfiguration.experimentMap.get(c), !f) return _logging.KameleoonLogger.error(_templateObject57 || (_templateObject57 = _taggedTemplateLiteral(["Experiment with id ", " not found for visitor ", ""])), c, b), (0, _tsRes.Err)(new _kameleoonError.KameleoonError(_kameleoonError.KameleoonException.FeatureFlagExperimentNotFound, c, b));
      if (g = f.variations.get(d), void 0 === g) return _logging.KameleoonLogger.error(_templateObject58 || (_templateObject58 = _taggedTemplateLiteral(["Variation with key ", " not found in experiment ", " for visitor ", ""])), d, f, b), (0, _tsRes.Err)(new _kameleoonError.KameleoonError(_kameleoonError.KameleoonException.FeatureFlagVariationNotFound, d, b));
      f = {
        type: f.type,
        experimentId: c
      }, g = {
        variationKey: d,
        variationId: g
      };
      var h = this.variationConfiguration.updateForcedExperimentVariation(b, c, {
        rule: f,
        varByExp: g,
        forceTargeting: e
      });
      return _logging.KameleoonLogger.debug(_templateObject59 || (_templateObject59 = _taggedTemplateLiteral(["RETURN: KameleoonClient._setForcedVariation(visitorCode: '", "', experimentId: ", ", variationKey: '", "', forceTargeting: ", ") -> (writeResult: ", ")"])), b, c, d, e, h), h;
    }
  }]);
}();
exports.KameleoonClient = KameleoonClient;